<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard>
          <ComiteCalendario></ComiteCalendario>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Comite',
  components: {
    ComiteCalendario: () => import('../components/ComiteCalendario')
  },
  data: () => ({
    page: {
      title: 'Calendario Y Comités'
    },
    breadcrumbs: [
      {
        text: 'Calendario Y Comités',
        disabled: true
      },
      {
        text: 'Comités GH',
        disabled: false
      }
    ]
  }),
  methods: {}
};
</script>
